import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import Modal from '../common/Modal';
import BackArrowIcon from '../../svg/BackArrowIcon';
import DownloadFileContainer from '../DownloadFileContainer';
import FileUploadContainer from '../FileUploadContainer';
import { uploadFileResource } from '../../service/resource.service';

export default function ResourceFileModal({ onCancel, onClose, open, fetchData }) {
  const [selectedFile, setSelFile] = useState('');
  const classData = useSelector((state) => state.classes.selectedClass);
  const { id: classId, orgId } = classData;
  const [isUploading, setIsUploading] = useState(false);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleFileUpload = async () => {
    // setIsUploading(true);
    onCancel();
    onClose();
    const key = enqueueSnackbar('File Uploading', {
      variant: 'loading',
      persist: true,
      className: 'loading-variant'
    });
    uploadFileResource(classId, selectedFile, orgId, currentUser.id)
      .then(() => {
        closeSnackbar(key);
        enqueueSnackbar('File Uploaded Successfully', {
          variant: 'success'
        });
        setSelFile('');
        fetchData();
        setIsUploading(false);
      })
      .catch(() => {
        closeSnackbar(key);
        enqueueSnackbar('Please try again later', {
          variant: 'error'
        });
        setIsUploading(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <>
          <IconButton style={{ marginRight: 10 }} onClick={() => onCancel()}>
            <BackArrowIcon />
          </IconButton>{' '}
          Add Attachments
        </>
      }
      cancelText="Cancel"
      onCancel={() => onCancel()}
      actionText="Save"
      onAction={() => handleFileUpload()}
      isCancelDisabled={isUploading}
      isBtnLoading={isUploading}
    >
      {selectedFile ? (
        <DownloadFileContainer title={selectedFile.name} onCancelClick={() => setSelFile('')} />
      ) : (
        <FileUploadContainer onFileChange={(f) => setSelFile(f)} />
      )}
    </Modal>
  );
}

ResourceFileModal.propTypes = {
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  fetchData: PropTypes.func,
  open: PropTypes.bool
};
